import type {ITeaserGroupItem} from '@smart/editorial-components';
import {TeaserGroup} from '@smart/editorial-components';
import type {TeaserGroupContent} from '@smart/website-aem-utils';
import {
  createLegalDisclaimerProps,
  createLinkProps,
} from '@smart/website-aem-utils';
import * as React from 'react';
import {useFeatureServices} from '../hooks/use-feature-services';
export interface TeaserGroupWrapperProps {
  readonly content: TeaserGroupContent;
}

export const TeaserGroupWrapper = React.memo(
  ({content}: TeaserGroupWrapperProps) => {
    const {historyService} = useFeatureServices();

    const {
      componentHeadline,
      items,
      indicatorBar,
      highlight,
      legalDisclaimers,
    } = content;

    const teaserGroupItems = React.useMemo(
      () =>
        items.map<ITeaserGroupItem>(
          ({headline, teaserText, teaserImage, secondaryImage, link}) => ({
            headline,
            teaserText,
            image: teaserImage,
            secondaryImage,
            cta: link && createLinkProps({historyService, content: link}),
          }),
        ),
      [items],
    );

    return (
      <TeaserGroup
        componentHeadline={componentHeadline}
        teaserGroupItems={teaserGroupItems}
        indicatorBar={indicatorBar}
        highlightHeadline={highlight}
        legalDisclaimers={createLegalDisclaimerProps(
          legalDisclaimers,
          historyService,
        )}
      />
    );
  },
  (prevProps, nextProps) => prevProps.content.id === nextProps.content.id,
);

TeaserGroupWrapper.displayName = `TeaserGroupWrapper`;
